export type NavMenuItemType = 'url' | 'page' | 'category';

export interface NavMenuItem {
  id: number;
  type: NavMenuItemType;
  url: string;
  name: string;
  parentID: number;
  items: NavMenuItem[];
}

export const navMenuItemFromResponse = (responseData: any): NavMenuItem => ({
  id: responseData.id,
  type: responseData.type,
  url: responseData.url,
  name: responseData.name,
  parentID: responseData.parent_id,
  items: (responseData.items ?? []).map(navMenuItemFromResponse),
});
